"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hrInterviewQuerySchema = exports.hrInterviewCancelSchema = exports.hrInterviewCompleteSchema = exports.hrInterviewScheduleSchema = exports.hrInterviewRecommendationEnum = exports.hrInterviewStatusEnum = exports.hrInterviewModeEnum = void 0;
const zod_1 = require("zod");
/**
 * HR PHASE 2C — interview (recruitment roadmap, follows 2B). One schema
 * covers both "Interview" and "Assessment" rounds — see the migration's own
 * header comment for why.
 */
exports.hrInterviewModeEnum = zod_1.z.enum(['IN_PERSON', 'VIDEO', 'PHONE']);
exports.hrInterviewStatusEnum = zod_1.z.enum(['SCHEDULED', 'COMPLETED', 'CANCELLED', 'NO_SHOW']);
exports.hrInterviewRecommendationEnum = zod_1.z.enum(['STRONG_YES', 'YES', 'NO', 'STRONG_NO']);
exports.hrInterviewScheduleSchema = zod_1.z.object({
    candidateId: zod_1.z.string().uuid(),
    round: zod_1.z.coerce.number().int().positive().max(20).optional(),
    mode: exports.hrInterviewModeEnum,
    scheduledAt: zod_1.z.coerce.date(),
    panelMemberIds: zod_1.z.array(zod_1.z.string().uuid()).min(1).max(10),
    notes: zod_1.z.string().trim().max(2000).optional(),
});
/** Recording feedback is a distinct act from scheduling — no PATCH-everything endpoint. */
exports.hrInterviewCompleteSchema = zod_1.z.object({
    feedback: zod_1.z.string().trim().min(3).max(4000),
    rating: zod_1.z.coerce.number().int().min(1).max(5),
    recommendation: exports.hrInterviewRecommendationEnum,
});
exports.hrInterviewCancelSchema = zod_1.z.object({
    reason: zod_1.z.string().trim().max(2000).optional(),
});
exports.hrInterviewQuerySchema = zod_1.z.object({
    candidateId: zod_1.z.string().uuid().optional(),
    status: exports.hrInterviewStatusEnum.optional(),
    cursor: zod_1.z.string().min(1).max(512).optional(),
    limit: zod_1.z.coerce.number().int().positive().max(200).default(50),
});
//# sourceMappingURL=hr-interview.schema.js.map